import React from 'react'

import {
  CTALink,
  LayoutContainer as Container,
  HeadingLarge,
  BodyText,
  Label,
} from '@pb/components'
import cn from 'classnames'
import { Link } from 'react-router-dom'

import { CART_ROUTES, EXTERNAL_ROUTES } from 'App/constants'

import styles from './GeneralError.scss'

const CTALinks = [
  {
    href: EXTERNAL_ROUTES.index,
    copyKey: 'checkout.error.page.to.start.page',
  },
  {
    // cart is an React route so need the Link component
    to: CART_ROUTES.CartOverview.path,
    copyKey: 'checkout.error.page.to.shopping.bag',
    tag: Link,
  },
  {
    href: EXTERNAL_ROUTES.customerService,
    copyKey: 'checkout.error.page.to.faq',
  },
  {
    href: EXTERNAL_ROUTES.customerService,
    copyKey: 'checkout.error.page.to.customer.service',
  },
  {
    href: EXTERNAL_ROUTES.contact,
    copyKey: 'checkout.error.page.to.contact.us',
  },
]

export interface GeneralErrorProps {
  verticallyCentered?: boolean
}

const GeneralError: React.FC<GeneralErrorProps> = ({ verticallyCentered }) => {
  return (
    <Container
      role="alert"
      className={cn(styles.container, verticallyCentered && styles.verticallyCentered)}
    >
      <HeadingLarge center>
        <Label copyKey="checkout.error.page.title" />
      </HeadingLarge>
      <BodyText className={styles.description} center>
        <Label copyKey="checkout.error.page.description" />
      </BodyText>
      <ul className={styles.CTALinks}>
        {CTALinks.map(({ tag = 'a', href, to, copyKey }) => (
          <li key={copyKey}>
            <CTALink
              ctaLink
              className={styles.link}
              data-testid="cta-link"
              Tag={tag}
              {...(tag === 'a' ? { href } : { to })}
            >
              <Label copyKey={copyKey} />
            </CTALink>
          </li>
        ))}
      </ul>
    </Container>
  )
}

export default GeneralError
